import { Routes, Route, Outlet, Navigate } from "react-router-dom";
import Analytics from "../../components/funnels-evaluation/analytics";
import FunnelsEvaluation from "../../components/funnels-evaluation/funnels-evaluation";
import AdOptimization from "../../components/funnels-evaluation/optimization";
import EvaluationOverview from "../../components/funnels-evaluation/overview";
import ZipCheck from "../../components/funnels-evaluation/zip-check";
// import ExportQueries from "../../components/funnels-evaluation/export-queries";

const FunnelsEvaluationPage = () => {
  return (
    <>
      <Routes>
        <Route element={<FunnelsEvaluation />}>
          <Route index path="overview" element={<EvaluationOverview />} />
          <Route path="insights" element={<Analytics />} />
          <Route path="optimization" element={<AdOptimization />} />
          <Route path="zipcheck" element={<ZipCheck />} />
          <Route path="*" element={<Navigate to="overview" />} />
          {/* <Route path="export-queries" element={<ExportQueries />} /> */}
        </Route>
      </Routes>
      <Outlet />
    </>
  );
};
export default FunnelsEvaluationPage;
